import { render, staticRenderFns } from "./TakePayment.vue?vue&type=template&id=6573c25b&scoped=true"
import script from "./TakePayment.vue?vue&type=script&lang=js"
export * from "./TakePayment.vue?vue&type=script&lang=js"
import style0 from "./TakePayment.vue?vue&type=style&index=0&id=6573c25b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573c25b",
  null
  
)

export default component.exports